import PropTypes from 'prop-types';
import React, { useState } from 'react';
import Icon from 'ViatoUi/Shared/DataDisplay/Icon';
import { FlexBox } from 'ViatoUi/Shared/Layouts/Flex';

import styles from './Dropdown.module.scss';

const Dropdown = ({ label, children, fullwidth }) => {
	const [open, setOpen] = useState(false);

	return (
		<div className={styles.dropdown} data-fullwidth={fullwidth} data-open={open}>
			<FlexBox alignItems='center' className={styles.header} justifyContent='space-between' onClick={() => setOpen(!open)}>
				{label}{' '}
				<Icon className={styles.icon} color='primary' icon='fa-plus' iconWeight='fas' size='m' onClick={() => setOpen(!open)} />
			</FlexBox>
			<div className={styles.content}>{children}</div>
		</div>
	);
};

Dropdown.propTypes = {
	label: PropTypes.string.isRequired,
	children: PropTypes.node.isRequired,
	fullwidth: PropTypes.bool
};

Dropdown.defaultProps = {
	fullwidth: false
};

export default Dropdown;
